module.exports = __webpack_public_path__ + "img/6_85.5ed4bdee.png";